import { useLanguage } from '@cobliteam/i18n';
import Icon, { type IconNames, type IconProps } from '@cobliteam/ui/icons';
import { getTextForLanguage } from '@cobliteam/ui-business/utils';
import { getSingular } from '@cobliteam/utils/pluralize';
import { memo } from 'react';
import type { PageWithCategory } from '../../../types';

interface PageItemProps {
  item: PageWithCategory;
}

export const PageItem = memo(({ item }: PageItemProps) => {
  if (!item) return null;
  const { currentLanguage } = useLanguage();
  const itemTitle = getTextForLanguage(item.title, currentLanguage);
  const title = item?.group ? `${getSingular(item.group)} - ${getSingular(itemTitle || '')}` : `${getSingular(itemTitle || '')}`;

  return (
    <button type='button' tabIndex={0} className={'flex w-full items-center justify-between text-xs'}>
      <div className='flex items-center justify-center gap-2'>
        {item.category.loading ? (
          <Icon name='loader-circle' className='size-3 animate-spin' />
        ) : (
          <Icon name={(item.sidebar?.icon as IconNames) || item.category.icon} color={item.category.color as IconProps['color']} />
        )}
        <div className='flex flex-col text-left'>
          <span className='text-[10px] text-gray-10'>
            {getSingular(item.category.name)} {item?.primary ? `- ${getSingular(item?.primary || '')}` : ''}
          </span>
          <span className='line-clamp-1'>{title}</span>
        </div>
      </div>
    </button>
  );
});
